module.exports = (__webpack_require__(4))(1722);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/dva/index.js from dll-reference vendorProd_library
// module id = 3
// module chunks = 42